import { CustomerSurveyModel } from '../models/request';
import { AuthenticatedUser } from '../models/response';
import { ApiClient } from '../util/api-client';

export class FeedbackService {
    public static async sumbitSurvey(survey: CustomerSurveyModel) {
        return ApiClient.post<CustomerSurveyModel, AuthenticatedUser>('feedbacks', survey);
    }
}
